
<Modal modalType="DemoNote" mayCancel="true" v-on:cancel="onOK">
  <h2>Demo Mode</h2>
  <p>
    This demo page lets you try out Browserboard's features.
    <strong>It doesn’t save your changes</strong>.
  </p>
  <p>
    To collaborate with someone else or save your work,
    <a href="/whiteboards/new_guest">make a new board</a>.
  </p>
  <div class="ButtonRow-FlexRight">
    <SignupButton></SignupButton>
    <button class="WBMBigButton m-primary" v-on:click="onOK">Close</button>
  </div>
</Modal>
